
import Vue from 'vue'
import { useTable } from '@/components/table/table-hook'

import { getHotelLabelList, editHotelLabel, delHotelLabel } from '@/api/hotel-label'

export default Vue.extend({
	components: {},
	data() {
		return {
			editHotelLabel,
			...useTable({
				name: '酒店标签',
				formdata: {
					/** ID */
					id: 0,
					/** 名称 */
					name: '',
				},
				getData: (query) => getHotelLabelList(query).then((res) => res.data),
				delData: (row) => delHotelLabel({ id: row.id }),
			}),
		}
	},
	created() {
		this.tableGetData()
	},
})
